import type { RouteRecordRaw } from 'vue-router';

const governmentResourcesRoutes: RouteRecordRaw[] = [
  {
    path: '/government-resources',
    name: 'GovernmentResources',
    redirect: '/government-resources/dashboard',
    meta: {
      title: 'Recursos Governamentais',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/dashboard',
    name: 'GovernmentResourcesDashboard',
    component: () => import('@/views/government-resources/Dashboard.vue'),
    meta: {
      title: 'Dashboard - Recursos Governamentais',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/programs',
    name: 'GovernmentPrograms',
    component: () => import('@/views/government-resources/programs/ProgramsList.vue'),
    meta: {
      title: 'Programas Governamentais',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/programs/new',
    name: 'NewGovernmentProgram',
    component: () => import('@/views/government-resources/programs/ProgramForm.vue'),
    meta: {
      title: 'Novo Programa Governamental',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/programs/:id',
    name: 'GovernmentProgramDetails',
    component: () => import('@/views/government-resources/programs/ProgramDetails.vue'),
    meta: {
      title: 'Detalhes do Programa',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/programs/:id/edit',
    name: 'EditGovernmentProgram',
    component: () => import('@/views/government-resources/programs/ProgramForm.vue'),
    meta: {
      title: 'Editar Programa Governamental',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/requests',
    name: 'GovernmentRequests',
    component: () => import('@/views/government-resources/requests/RequestsList.vue'),
    meta: {
      title: 'Solicitações de Recursos',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/budget',
    name: 'GovernmentBudget',
    component: () => import('@/views/government-resources/budget/BudgetOverview.vue'),
    meta: {
      title: 'Orçamento Governamental',
      requiresAuth: true
    }
  },
  {
    path: '/government-resources/reports',
    name: 'GovernmentReports',
    component: () => import('@/views/government-resources/reports/ReportsList.vue'),
    meta: {
      title: 'Relatórios Governamentais',
      requiresAuth: true
    }
  }
];

export default governmentResourcesRoutes;